import type { Router } from 'vue-router'

export default defineNuxtPlugin(nuxtApp => {
  const router = nuxtApp.$router as Router | undefined
  if (!router) {
    return
  }
  let shouldScrollTopAfterPageReady = false

  router.afterEach((to, from, failure) => {
    if (failure) {
      shouldScrollTopAfterPageReady = false
      return
    }

    // 同一路径（query/hash 变化）交由页面业务逻辑处理
    if (to.path === from.path) {
      shouldScrollTopAfterPageReady = false
      return
    }

    shouldScrollTopAfterPageReady = true
  })

  nuxtApp.hook('page:finish', () => {
    if (!shouldScrollTopAfterPageReady || !import.meta.client) {
      return
    }
    shouldScrollTopAfterPageReady = false
    window.requestAnimationFrame(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'auto' })
    })
  })
})
